import { put, takeEvery } from "redux-saga/effects";
import type { SpEnvironmentType } from "InterfacesTypes/types"
import { loadSpEnvironment, markInitialized, setSpEnvironment } from "state/reducers/SPEnvironmentReducer";

function* loadSpEnvironmentSaga() {
    const domain: string = window.location.hostname.split(".")[0];
    let spEnv: SpEnvironmentType = "logistikportalen";

    if (domain === "logp") {
        spEnv = "logp";
    }
    // If you want to see how it looks change between "logp" and "logistikportalen".
    if (domain === "localhost") {
        spEnv = "logp"
    }

    if (spEnv) {
        yield put(setSpEnvironment(spEnv));
        //yield put(setSpEnvironment("logistikportalen"));
    }

    yield put(markInitialized());
}

export function* spEnvironmentSaga() {
    yield takeEvery(loadSpEnvironment.type, loadSpEnvironmentSaga);
}